import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Toast from './components/Toast';
import useToast from './hooks/useToast';

import Login from './pages/Login';
import DashboardPage from './pages/Dashboard';
import AccountCodePage from './pages/master-data/AccountCode';
import CurrencyPage from './pages/master-data/Currency';
import NationalityPage from './pages/master-data/Nationality';
import CustomerPage from './pages/master-data/Customer';
import BeneficiaryPage from './pages/master-data/Beneficiary';
import PartnerPage from './pages/master-data/Partner';
import BankUmumPage from './pages/master-data/BankUmum';
import BankAccountPage from './pages/master-data/BankAccount';
import ExpenseTypePage from './pages/master-data/ExpenseType';
import IncomeTypePage from './pages/master-data/IncomeType';
import BuySellPage from './pages/transactions/BuySell';
import RemittancePage from './pages/transactions/Remittance';
import TransferPage from './pages/transactions/Transfer';
import ExpensePage from './pages/transactions/Expense';
import IncomePage from './pages/transactions/Income';
import UploadPage from './pages/transactions/Upload';
import UploadDocumentPage from './pages/transactions/UploadDocument';
import MonthlyClosingPage from './pages/transactions/MonthlyClosing';
import BuySellReportPage from './pages/reports/BuySellReport';
import BankReportPage from './pages/reports/BankReport';
import ExpenseIncomeReportPage from './pages/reports/ExpenseIncomeReport';
import ProfitLossReportPage from './pages/reports/ProfitLossReport';
import CurrencyBalanceReportPage from './pages/reports/CurrencyBalanceReport';
import SettingsPage from './pages/Settings';

export default function App() {
  const { toast, show } = useToast();

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <Layout onToast={show} />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/account-codes" element={<AccountCodePage onToast={show} />} />
          <Route path="/currencies" element={<CurrencyPage onToast={show} />} />
          <Route path="/nationalities" element={<NationalityPage onToast={show} />} />
          <Route path="/customers" element={<CustomerPage onToast={show} />} />
          <Route path="/beneficiaries" element={<BeneficiaryPage onToast={show} />} />
          <Route path="/partners" element={<PartnerPage onToast={show} />} />
          <Route path="/bank-umum" element={<BankUmumPage onToast={show} />} />
          <Route path="/bank-accounts" element={<BankAccountPage onToast={show} />} />
          <Route path="/expense-types" element={<ExpenseTypePage onToast={show} />} />
          <Route path="/income-types" element={<IncomeTypePage onToast={show} />} />
          <Route path="/transactions/buy-sell" element={<BuySellPage onToast={show} />} />
          <Route path="/transactions/remittance" element={<RemittancePage onToast={show} />} />
          <Route path="/transactions/transfer" element={<TransferPage onToast={show} />} />
          <Route path="/transactions/expense" element={<ExpensePage onToast={show} />} />
          <Route path="/transactions/income" element={<IncomePage onToast={show} />} />
          <Route path="/transactions/upload" element={<UploadPage onToast={show} />} />
          <Route path="/transactions/upload-document" element={<UploadDocumentPage onToast={show} />} />
          <Route path="/transactions/monthly-closing" element={<MonthlyClosingPage onToast={show} />} />
          <Route path="/reports/buy-sell" element={<BuySellReportPage />} />
          <Route path="/reports/bank" element={<BankReportPage />} />
          <Route path="/reports/expense-income" element={<ExpenseIncomeReportPage />} />
          <Route path="/reports/profit-loss" element={<ProfitLossReportPage />} />
          <Route path="/reports/currency-balance" element={<CurrencyBalanceReportPage />} />
          <Route path="/settings" element={<SettingsPage onToast={show} />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <Toast toast={toast} />
    </>
  );
}
